import { showSuccess, showError, getResponseErrors } from 'utils/messages';
import { trackingPageUrl, submitPostViaHiddenForm } from 'utils/wrappers';

import Brand from 'app/models/brand';

import Base from 'app/views/base';
import ColorPickerView from 'app/views/color_picker_view';
import ImageUploadView from 'app/views/image_upload_view';

import tmpl from 'templates/brand_page';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'brand',

  events: {
    'submit #brand-form': 'submit',
    'click #preview-tracking-page': 'previewTrackingPage',
    'keyup #ad_href,#logo_href,#name': 'setModelFromId'
  },

  initialize({ user}) {
    this.user = user;
    this.model = new Brand({ user: this.user });
    this.listenTo(this.model, 'sync', this.render);
    this.adImgMinWidth = 460;

    this.addSubview('colorPicker', '#color_picker', new ColorPickerView({ model: this.model }));
    this.addSubview('logoImageUpload', '#logo_image_upload', new ImageUploadView({ model: this.model, modelProperty: 'logo' }));
    this.addSubview('adImageUpload', '#ad_image_upload', new ImageUploadView({ model: this.model, modelProperty: 'ad', minWidth: this.adImgMinWidth }));

    this.model.fetch();
  },

  context() {
    return {
      adHref: this.model.get('ad_href'),
      adImgMinWidth: this.adImgMinWidth,
      brandName: this.model.get('name'),
      logoHref: this.model.get('logo_href'),
    }
  },

  afterRender() {
    this.$('[data-toggle="tooltip"]').tooltip();
  },


  setModelFromId(e) {
    this.model.set(e.target.id, $(e.target).val());
  },

  previewTrackingPage() {
    submitPostViaHiddenForm(trackingPageUrl('test'), this.model.toJSON({ includeHrefs: true }));
  },

  submit(e) {
    e.preventDefault();
    const self = this;
    this.model.save({}, {
      success() {
        self.render();
        showSuccess('Brand Successfully Updated.');
      },
      error(model, response) {
        self.render();
        showError(getResponseErrors(response)[0].message);
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/brand_page.js